import React, { memo, useContext } from 'react';
import { StyleSheet, css } from 'aphrodite';
import './css/HomePage1Section18.css';
import { context } from '../../../../globalState/GlobalState';
import HomePage1FeatureImagesCarousel4 from '../uiElements/homePage1FeatureImagesCarousels/homePage1FeatureImagesCarousel4/HomePage1FeatureImagesCarousel4';
import HomePage1Articles1 from '../uiElements/homePage1Articles/homePage1Articles1/HomePage1Articles1';
import HomePage1ArticlesCarousel2 from '../uiElements/homePage1ArticlesCarousels/homePage1ArticlesCarousel2/HomePage1ArticlesCarousel2';

const HomePage1Section12 = () => {
    const { globalState } = useContext(context);

    const styles = StyleSheet.create({
        container: {
            backgroundColor: globalState.websiteStyles.colors.primaryColor,
        },
    });

    return (
        <div className={`homepage1-section18-container-container p-t-50px p-b-50px ${css(styles.container)}`}>
            <div className="homepage1-section18-triangle" />
            <ul className="homepage1-section18-vertical-line">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
                <li></li>
            </ul>
            <div className="homepage1-section18-container box-shadow-black x-center">
                <HomePage1FeatureImagesCarousel4 />
                <div className="homepage1-section18-desktop">
                    <HomePage1ArticlesCarousel2 />
                </div>
                <div className="homepage1-section18-mobile">
                    <HomePage1Articles1 />
                </div>
            </div>
        </div>
    );
};

export default memo(HomePage1Section12);
